"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureToggle = void 0;
const common_components_1 = require("@as-react/common-components");
const useFeatureToggle = (flagName) => {
    const { feature_toggles } = (0, common_components_1.useAemConfig)();
    return !!feature_toggles[flagName];
};
exports.useFeatureToggle = useFeatureToggle;
